<template>
  <div class="talent-search__wrapper">
    <div class="talent-search__container">
      <div class="talent-search__content">
        <div class="talent-search__left">
          <h3 class="talent-search__title">Як тебе знаходять кастинги</h3>
          <div class="talent-search__left-list">
            <div
              v-for="(item, i) in list"
              class="talent-search__left-item"
              :key="item.key"
              :class="{
                'talent-search__left-item__no-top': i === 0,
                'talent-search__left-item__no-bottom': i === list.length - 1,
              }"
            >
              <p class="talent-search__left-key">{{ item.key }}</p>
              <p class="talent-search__left-text">{{ item.text }}</p>
            </div>
          </div>
        </div>
        <div class="talent-search__right">
          <video
            class="talent-search__img"
            autoplay
            muted
            playsinline
            webkit-playsinline
            loop
            preload="metadata"
          >
            <source
              src="/static/video/find-you-mobile.mp4"
              type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'
            />
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "how-do-we-search-block",
  data() {
    return {
      title: "Як тебе знаходять кастинги",
      list: [
        {
          key: 1,
          text: "Сторінка з твоєю анкетою з'являється на нашій платформі.",
        },
        {
          key: 2,
          text: "Замовник описує свій проєкт, умови участі в ньому та шукає талантів в нашій базі.",
        },
        {
          key: 3,
          text: "Якщо твій типаж підходить — отримуєш запрошення на кастинг в телеграм-бот.",
        },
        {
          key: 4,
          text: "Ти вирішуєш. Дивишся деталі проєкту, умови, гонорар, дати зйомки. Погоджуєшся, або відкидаєш пропозицію.",
        },
        {
          key: 5,
          text: "Якщо погодився, організатор зв'язується з тобою напряму для обговорення наступних кроків.",
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.talent-search {
  &__wrapper {
    max-width: 1440px;
    margin: 0 auto;
    width: 100%;
  }

  &__container {
    padding: 160px 104px;
  }

  &__content {
    justify-content: space-between;
    display: flex;
  }

  &__title {
    font-family: "Inter", sans-serif;

    font-size: 60px;
    font-weight: 500;
    line-height: 60px;
    letter-spacing: -0.02em;
    max-width: 637px;
    padding-bottom: 60px;
  }

  &__left {
    padding-top: 80px;

    &-list {
    }

    &-item {
      display: flex;
      max-width: 519px;
      column-gap: 60px;
      padding-bottom: 24px;
      padding-top: 24px;
      border-bottom: 1px solid #00000033;
      &__no-top {
        padding-top: 0;
      }
      &__no-bottom {
        padding-bottom: 0;
        border-bottom: none;
      }
    }

    &-key {
      font-family: "Nyght Serif";

      font-size: 53px;
      line-height: 53px;
      letter-spacing: 0.1em;
      font-weight: 300;
      min-width: 30px;
    }

    &-text {
      font-family: "Inter", sans-serif;

      font-size: 20px;
      line-height: 28px;
    }
  }

  &__img {
    display: block;
    max-width: 100%;
    width: 520px;
    height: auto;
    object-fit: cover;
  }
}

@media (max-width: 1230px) {
  .talent-search {
    &__container {
      padding: 120px 24px;
    }
  }
}

@media (max-width: 997px) {
  .talent-search {
    &__title {
      font-size: 36px;
      line-height: 36px;
    }

    &__left {
      padding-top: 0;

      &-item {
        column-gap: 12px;
      }
    }
  }
}
@media (max-width: 776px) {
  .talent-search {
    &__content {
      flex-direction: column;
    }

    &__right {
      display: flex;
      justify-content: center;
      overflow-y: hidden;
    }

    &__left {
      &-text {
        font-size: 16px;
        line-height: 22px;
      }
    }
    &__img {
      width: 375px;
      height: auto;
      overflow: hidden;
    }
  }
}
</style>
